export function twitchPlaceholder(chanel) {
    return `<iframe src="https://player.twitch.tv/?channel=${chanel}&parent=media.vkplay.ru&autoplay=false" frameborder="0" allowfullscreen="true" scrolling="no" height="378" width="620"></iframe>`;
}

export function twitchPlaceholderClip(clip) {
    return `<iframe src="https://clips.twitch.tv/embed?clip=${clip}&parent=media.vkplay.ru&autoplay=false" frameborder="0" allowfullscreen="true" scrolling="no" height="378" width="620"></iframe>`;
}

export function twitchPlaceholderVideo(video, collection) {
    return `<iframe src="https://player.twitch.tv/?${collection ? `collection=${collection}&` : ''}video=${video}&parent=media.vkplay.ru&autoplay=false" frameborder="0" allowfullscreen="true" scrolling="no" height="378" width="620"></iframe>`;
}

export function telegramPlaceholder(post) {
    return `<script async src="https://telegram.org/js/telegram-widget.js?14" data-telegram-post="${post}" data-width="100%"></script>`;
}
